import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../app/hooks";
import { socket } from "../../socket";

import styles from "./LoginForm.module.css";

export default function LoginForm() {
  const [isUsernameAdded, setIsUsernameAdded] = useState<boolean>(false);
  const [userName, setUserName] = useState<string>();

  const roomId = useAppSelector((state) => state.user.roomId);
  const isUsernameUnique = useAppSelector(
    (state) => state.user.isUsernameUnique,
  );

  const { t } = useTranslation();

  if (isUsernameAdded && !isUsernameUnique) {
    setIsUsernameAdded(false);
  }

  function onChange(e: React.ChangeEvent<HTMLInputElement>) {
    setUserName(e.target.value);
  }

  function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setIsUsernameAdded(true);
    socket.emit("login", roomId, userName);
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <h3 className={styles.title}>{t("LoginForm.title")}</h3>
        <form className={styles.form} onSubmit={onSubmit}>
          <div className={styles.form__group}>
            <input
              className={styles.form__field}
              id="username"
              name="username"
              type="text"
              placeholder={String(t("LoginForm.placeholder"))}
              onChange={onChange}
              required
              autoFocus
            />
            <label className={styles.form__label} htmlFor="username">
              {t("LoginForm.label")}
            </label>
          </div>
          {!isUsernameUnique && (
            <div className={styles.error}>
              {t("LoginForm.errorUsernameTaken")}
            </div>
          )}
          <div className={styles.form__actions}>
            {isUsernameAdded ? (
              <button
                className={[styles.form__button, "loading-state"].join(" ")}
                type="submit"
                disabled
              >
                {t("App.submitting")}
              </button>
            ) : (
              <button className={styles.form__button} type="submit">
                {t("LoginForm.submitButton")}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
